<template>
    <ul class="o-project-nav-translator">
        <li>
            <router-link
                :to="{
                    name: 'project-translations',
                    params: {
                        projectUuid,
                    },
                }"
            >
                <i class="uil uil-schedule"></i>
                {{ $t('app.Translations') }}
            </router-link>
        </li>
        <li>
            <router-link
                :to="{
                    name: 'project-notifs',
                    params: {
                        projectUuid,
                    },
                }"
            >
                <i class="uil uil-message"></i>
                {{ $t('app.Notifs') }}
            </router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'OProjectNavTranslator',
    props: {
        projectUuid: {
            type: String,
            required: true
        },
    }
 }
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
